import type { ObjectSummary } from './types';

const objectTypeLabels: Record<string, string> = {
  'vc-modern': 'VC', 'vc-legacy': 'VC', 'vc-unknown': 'VC',
  'in-modern': 'IN', 'in-unknown': 'IN',
  co: 'CO', 'co-unknown': 'CO',
  sq: 'SQ', 'sq-unknown': 'SQ',
  rs: 'RS', 'rs-unknown': 'RS',
  px: 'PX', 'px-unknown': 'PX',
  ai: 'AI', 'ai-unknown': 'AI',
  'mcl-pc': 'PC', 'mcl-pc-unknown': 'PC',
  'mcl-pt': 'PT', 'mcl-pt-unknown': 'PT',
  'mcl-ss': 'SS', 'mcl-ss-unknown': 'SS',
};

export type ObjectSortKey = 'name' | 'type' | 'size';
export type SortDirection = 'ascending' | 'descending';

const natural = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

export function displayObjectType(kind: string, suffix = ''): string {
  return objectTypeLabels[kind] ?? (suffix || 'Other');
}

export function formatBytes(bytes: number | null | undefined): string {
  if (bytes === null || bytes === undefined) return 'Unavailable';
  if (bytes < 1024) return `${bytes} B`;
  return `${(bytes / 1024).toFixed(2)} KiB`;
}

export function sortObjects(objects: ObjectSummary[], key: ObjectSortKey, direction: SortDirection): ObjectSummary[] {
  const sign = direction === 'ascending' ? 1 : -1;
  return [...objects].sort((left, right) => {
    let primary = 0;
    if (key === 'name') primary = natural.compare(`${left.name}.${left.suffix}`, `${right.name}.${right.suffix}`);
    else if (key === 'type') primary = natural.compare(displayObjectType(left.kind, left.suffix), displayObjectType(right.kind, right.suffix));
    else if (left.size === null || right.size === null) {
      if (left.size === null && right.size !== null) return 1;
      if (left.size !== null && right.size === null) return -1;
    } else primary = left.size - right.size;
    if (primary) return primary * sign;
    const byName = natural.compare(`${left.name}.${left.suffix}`, `${right.name}.${right.suffix}`);
    return byName || left.id - right.id;
  });
}
